import React, { useEffect, useState } from "react";
import "./result.css";
import { useLocation, useNavigate } from "react-router-dom";
import { getStationApi } from "../../Api/baseApi";

const EmotionRate = ({ data }: { data: string[] }) => {
  const [emotion, rate] = data;

  return (
    <div className="flex items-center justify-between py-4 pl-6 text-black bg-white pr-9 rounded-2xl">
      <div className="flex items-center">
        {rate !== "-" && (
          <img className="w-12" src={`/imgs/etc/${emotion}_mini.png`} alt="" />
        )}
        <p className="ml-4 mr-24 text-2xl capitalize bold ">{emotion}</p>
      </div>
      <p className="text-[25px] bold">{rate}</p>
    </div>
  );
};

const EmotionType = ({
  emotion,
  statuses,
}: {
  emotion: string;
  statuses: string[][];
}) => {
  return (
    <div className="p-6 bg-[rgba(255,255,255,0.16)] border border-white rounded-2xl">
      <p className="inline-block bg-gradient-to-r from-[#F95485] to-[#D139D5] py-1 px-5 text-white bold rounded-md mb-6 capitalize">
        {emotion}
      </p>
      <div className="grid grid-cols-2 gap-8">
        {statuses.map((el, idx) => (
          <EmotionRate key={idx} data={el} />
        ))}
      </div>
    </div>
  );
};

export const Result = () => {
  const [emoitnos, setEmoitnos] = useState<{ [idx: string]: string[][] }>({});
  const [keys, setKeys] = useState<string[]>([]);
  const [isStationReady, setIsStationReady] = useState(false);
  const [stationIdx, setStationIdx] = useState(0);
  const [imgUrl, setImgUrl] = useState("");
  const [resaultEmotion, setResaultEmotion] = useState<string>("");
  const [musicList, setMusicList] = useState([]);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const { data, imgUrl } = location.state;
    const { stationId, best, ...emotion } = data;

    (async () => {
      const { data } = await getStationApi(1, stationId);

      setStationIdx(stationId);
      setMusicList(data);
      setIsStationReady(true);
    })();
    setResaultEmotion(best);
    // setImgUrl(imgUrl);
    setEmoitnos(emotion);
    setKeys(Object.keys(emotion));
  }, []);

  return (
    <div className="relative flex items-center justify-center w-full h-full p-24 text-white gap-52">
      <div className="text-center">
        <p className="text-6xl">Your feeling is</p>
        <img
          className="w-[450px] py-10"
          src={`/imgs/etc/${resaultEmotion}.png`}
          alt=""
        />
        <p className="uppercase text-7xl bold">{resaultEmotion}</p>
      </div>
      <div className="flex flex-col gap-9">
        {keys.map((el) => (
          <EmotionType key={el} emotion={el} statuses={emoitnos[el]} />
        ))}
      </div>
      {isStationReady && (
        <button
          onClick={() => {
            navigate("/musiclist", {
              state: { imgUrl, musicList, stationIdx, resaultEmotion },
            });
          }}
          className="absolute text-center bottom-12 right-12"
        >
          <p className="mb-4 text-4xl uppercase">next</p>
          <img className="w-28" src="/imgs/etc/next.png" alt="" />
        </button>
      )}
    </div>
  );
};
